<template>
  <div>
    <!-- FBA操作单总汇-->
    <baseBreadcrumb :page="$t('message.FBAOperationOrder')" :menu="$t('message.listOfGoods')" />
    <!-- 服务单列表 -->
    <section>
      <div class="header">
        <!-- 服务单 -->
        <div class="tabs">
          <el-tabs v-model="datas.status" type="card" @tab-click="search">
            <!-- 检品完了 -->
            <el-tab-pane :label="item.name + '(' + item.count + ')'" :name="item.key + ''"
              v-for="(item, index) in listTabCount" :key="index"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="headerContainer">
          <div class="leftContainer">
            <div class="Container">
              <el-date-picker v-model="datas.datetimeStart" type="date" value-format="yyyy-MM-dd" clearable
                :placeholder="$t('message.startDate')">
              </el-date-picker>
            </div>
            <div class="Container">
              <el-date-picker v-model="datas.datetimeEnd" type="date" :placeholder="$t('message.dateClosed')"
                value-format="yyyy-MM-dd" clearable>
              </el-date-picker>
            </div>

            <div class="Container">
              <!-- 订单号 -->
              <el-input v-model="datas.order_sn" clearable onfocus="this.select()"
                :placeholder="$t('message.orderNumber')"></el-input>
            </div>
            <!-- 配送单号：服务单列表接口参数 porder_sn -->
            <div class="Container">
              <el-input v-model="datas.porder_sn" clearable onfocus="this.select()"
                :placeholder="$t('message.pleaseEnterTheShippingNumber')"></el-input>
            </div>
            <!--客户ID -->
            <div class="Container">
              <el-input v-model="datas.user_id" clearable onfocus="this.select()"
                :placeholder="$t('message.clientID')"></el-input>
            </div>
            <!--服务单号 -->
            <div class="Container">
              <el-input v-model="datas.service_sn" clearable onfocus="this.select()"
                :placeholder="$t('message.serviceOrderNumber')"></el-input>
            </div>
            <!--服务单操作员 -->
            <div class="Container">
              <el-select v-model="datas.admin_id" clearable onfocus="this.select()"
                :placeholder="$t('message.serviceOperator')" filterable>
                <el-option :label="item.realname" :value="item.id" v-for="(item) in jList" :key="item.id"></el-option>
              </el-select>
            </div>
            <!--提出人 -->
            <div class="Container">
              <el-select v-model="datas.created_by" clearable onfocus="this.select()"
                :placeholder="$t('message.forwarder')" filterable>
                <el-option :label="item.realname" :value="item.id" v-for="(item) in adminList"
                  :key="item.id"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="headerContainer">
          <div class="leftContainer">
            <!-- 是否Fba订单 -->
            <div class="Container">
              <el-select v-model="datas.hasFba" placeholder="是否有FBA 的option" clearable>
                <el-option value="1" :label="$t('message.are')"></el-option>
                <el-option value="0" :label="$t('message.no')"></el-option>
              </el-select>
            </div>
            <div class="Container">
              <!-- 搜索 -->
              <el-button type="primary" @click="search">{{
                $t("message.search")
              }}</el-button>
              <!-- 重置 -->
              <el-button @click="reset">
                {{ $t("message.reset") }}
              </el-button>
            </div>
          </div>

        </div>
      </div>
      <div class="footer">
        <div class="footerContainer">
          <div class="table">
            <!-- 无数据显示 -->
            <div class="noData" v-if="tableData == false">暂无数据</div>
            <!-- 订单详情 -->
            <div class="detail" v-for="(orderItem, index) in tableData" :key="index">
              <div class="head">
                <div class="row">
                  <div class="checkbox">
                    <el-checkbox v-model="orderItem.checked" @change="serviceChecked"></el-checkbox>
                  </div>

                  <!-- 是否显示 -->
                  <div class="show" @click="isShow(orderItem)">
                    <el-button size="mini">{{ !orderItem.show ? '收起' : '展开' }}
                      <i :class="orderItem.show ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
                    </el-button>
                  </div>
                  <!-- 提出时间 -->
                  <div class="item">
                    {{ $t("message.forwardTime") }}：{{ orderItem.created_at }}
                  </div>
                  <!-- 服务单号: -->
                  <div class="item order">
                    {{ $t("message.serviceOrderNumber") }}：
                    <router-link :to="'/serviceDetail?service_sn=' + orderItem.service_sn
                      " target="_blank">
                      <span class="acli">
                        {{ orderItem.service_sn }}
                      </span>
                    </router-link>
                    <!-- 客户属性 -->
                    <span style="width: 80px;">
                      <attributeName :name="orderItem.attribute_name" />
                    </span>
                    <i class="el-icon-copy-document" @click="copy(orderItem.service_sn)"></i>
                  </div>
                  <!-- 提出人 -->
                  <div class="item">
                    {{ $t("message.forwarder") }}：
                    {{ orderItem.created_admin != null ? orderItem.created_admin.realname : '' }}
                  </div>
                  <!-- 服务单处理 -->
                  <div class="item">
                    {{ $t('message.serviceOperator') }}: {{ orderItem.admin_admin != null ?
                      orderItem.admin_admin.realname
                      : '' }}
                  </div>
                  <!-- 要求完成时间时间 -->
                  <div class="item">
                    {{ $t('message.requiredCompletionTime') }}: {{ orderItem.need_complete_at }}
                  </div>
                  <!-- 服务单类型 -->
                  <div class="item">
                    <div>
                      <el-button :type="setType(orderItem.cate_id)" :class="{ primary: orderItem.cate_id == 2 }">{{
                        orderItem.cate_name }}</el-button>
                    </div>
                  </div>
                </div>
                <!-- 统计 -->
                <div class="total">
                  <!-- 总计需要操作： -->
                  <div class="label">{{ $t("message.totalNeedsOperation") }}：</div>
                  <div class="item" v-for="(item, index) in orderItem.total" :key="index">
                    {{ item.name }}: <span>{{ item.should }}</span></div>
                </div>
              </div>
              <div class="orderDetailOpt" v v-show="!orderItem.show">
                <ol>
                  <!-- 选择 -->
                  <li class="flex05">{{ $t("message.choose") }}</li>
                  <!--  订单号-->
                  <li class="flex15">
                    {{ $t("message.orderNumber") }}
                  </li>
                  <!-- 番号 -->
                  <li class="flex05" @click="allChecked">{{ $t("message.mash") }}</li>
                  <!--照片-->
                  <li>
                    {{ $t("message.pic") }}
                  </li>
                  <!-- 业务编辑商品属性 -->
                  <li class="flex15">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
                  <!-- 购买信息 -->
                  <li>{{ $t("message.purchaseInformation") }}</li>
                  <!-- 附加服务 -->
                  <li class="flex15">{{ $t("message.additionalServices") }}</li>
                  <!-- 担当备注 -->
                  <li class="flex15">
                    {{ $t("message.responsibleForRemarks") }}
                  </li>
                  <!-- 核查员备注 -->
                  <li class="flex15">
                    {{ $t("message.verifierSNotes") }}
                  </li>

                  <!-- 操作内容-需要操作数量 -->
                  <li class="flex2">
                    {{ $t("message.operationContentNeedsOperationQuantity") }}{{ datas.status == 20 ? '-实际操作数量' : '' }}
                  </li>
                  <!-- 检品组长备注 -->
                  <li class="flex15">
                    {{ $t("message.inspectionLeaderRemark") }}
                  </li>
                  <!-- 操作人员备注 -->
                  <li class="flex15">
                    {{ $t("message.operationPersonnelRemark") }}
                  </li>
                  <!-- 状态 -->
                  <li>{{ $t("message.status") }}</li>
                </ol>
                <ul v-for="(goodsItem, indexs) in orderItem.option_service_detail" :key="indexs">
                  <!-- 选择 -->
                  <li class="flex05">
                    <label>
                      <el-checkbox v-model="goodsItem.checked" @change="changeItem"></el-checkbox>
                    </label>
                  </li>
                  <!--  订单号-->
                  <li class="flex15">
                    <router-link :to="'/orderPaymentDetail?order_sn=' + goodsItem.order_detail.order_sn" target="_blank"
                      class="a-link">{{ goodsItem.order_detail.order_sn }}</router-link>
                  </li>
                  <li class="flex05">
                    {{ goodsItem.order_detail.sorting }}
                  </li>
                  <!--照片-->
                  <li>
                    <div>
                      <div class="img">
                        <el-popover placement="right" width="300" trigger="hover">
                          <img :src="goodsItem.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                          <a :href="goodsItem.order_detail.link.goods_url" target="_blank" slot="reference">
                            <img :src="goodsItem.order_detail.pic" alt="" />
                          </a>
                        </el-popover>
                      </div>
                    </div>
                  </li>
                  <!-- 商品属性 -->
                  <li class="flex15">
                    <div class="template">
                      <p v-for="(skuItem, skuIndex) in goodsItem
                        .order_detail.detail_y" :key="skuIndex">
                        <span>{{ skuItem.key }}:</span>
                        <span>{{ skuItem.value }}</span>
                      </p>
                    </div>
                  </li>
                  <!-- 购买信息 -->
                  <li>
                    <div class="template">
                      <p>数量：{{ goodsItem.order_detail.confirm_num }}</p>
                      <p>单价：{{ goodsItem.order_detail.confirm_price }}</p>
                    </div>
                  </li>
                  <!-- 附加服务 -->
                  <li class="flex15">
                    <div class="template">
                      <el-tag v-if="Number(goodsItem.order_detail.is_fba_pre) === 1" type="success" size="mini">标签前置处理</el-tag>
                      <el-tooltip placement="bottom">
                        <div slot="content">
                          <div class="row" v-for="(opti, optiIndex) in goodsItem
                            .order_detail.option" :key="optiIndex" style="margin-bottom: 3px">
                            <p>
                              {{ optiIndex + 1 }}.{{ opti.name }}:
                              <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                              <span v-else> {{ opti.price }}% </span>
                            </p>
                          </div>
                        </div>
                        <div style="height: 100px">
                          <div class="row" v-for="(opti, optiIndex) in goodsItem
                            .order_detail.option" :key="optiIndex">
                            <p>
                              {{ optiIndex + 1 }}.{{ opti.name }}:
                              <span v-if="opti.price_type != 1">{{ opti.num }}</span>
                              <span v-else> {{ opti.price }}% </span>
                            </p>
                          </div>
                        </div>
                      </el-tooltip>
                    </div>
                  </li>
                  <!-- 担当备注 注:担当就是业务员-->
                  <li class="flex15">
                    {{ goodsItem.order_detail.y_remark }}
                  </li>
                  <!-- 核查员备注 注:核查员就是配货-->
                  <li class="flex15">
                    {{ goodsItem.order_detail.p_remark }}
                  </li>
                  <!-- 操作内容-需要操作数量 -->
                  <li class="flex2">
                    <div class="template">
                      <div class="row extra_options" v-for="(extra, extraIndex) in goodsItem.extra_options"
                        :key="extraIndex">
                        <div class="name">{{ extra.name }}</div>
                        <div class="num">{{ extra.should }}</div>
                        <div class="num" style="color:#2C96E7" v-if="datas.status == 20">{{ extra.complete }}</div>
                      </div>
                    </div>
                  </li>

                  <!-- 检品组长备注 -->
                  <li class="flex15">
                    <optionServiceRemark :detail="goodsItem" field="leader_remark" />
                  </li>
                  <!-- 操作人员备注 -->
                  <li class="flex15">
                    <optionServiceRemark :detail="goodsItem" field="mechanic_remark" />
                  </li>
                  <!-- 状态 -->
                  <li>
                    <div>
                      <span>
                        {{ goodsItem.status_name
                        }}
                      </span>
                      <p v-if="goodsItem.status_name == '服务完成'"> {{ $t("message.completionTime") }}：{{
                        goodsItem.complete_at }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 服务待处理状态下，可对勾选的多个服务单批量调配操作人。 -->
          <div class="operation" v-if="datas.status == '0'">
            <div class="service-selection">
              <el-checkbox v-model="serviceCheckedAll" @change="allServiceChecked" />
              <span>{{ $t('message.allChecked') }}</span>
              <span>{{ $t('message.selectedServiceOrderCount', { count: selectedServiceOrders.length }) }}</span>
            </div>
            <el-button type="primary" size="small" v-if="isAuth(590)" @click="openBatchDispatch">
              {{ $t('message.batchDispatchServiceOperator') }}
            </el-button>
          </div>
          <!-- 分页 -->
          <div class="paginationContainer">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="datas.page" :page-sizes="[20, 50, 100, 200]" :page-size="datas.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </section>
    <batchServiceAdminDispatch ref="batchServiceAdminDispatch" @refresh="optionServiceList" />
  </div>
</template>
<script>
import batchServiceAdminDispatch from '../components/batchServiceAdminDispatch'

export default {
  components: { batchServiceAdminDispatch },

  data() {
    return {
      total: {},
      datas: {
        page: 1,
        pageSize: 20,
        status: "0",
        datetimeStart: "",
        datetimeEnd: "",
        user_id: "",
        order_sn: "",
        porder_sn: "",
        service_sn: "",
        admin_id: "",
        created_by: "",
        cate_id: 5,
      },
      tableData: [],
      total: 0,
      checkedList: [], //选中的商品
      serviceCheckedAll: false, //当前页服务单全选
      cateList: [],//服务单类型
      jList: [],//服务单-可选检品操作人员
      adminList: [],//服务单-可选服务人员
      listTabCount: [],//服务单-服务单类型数量

    };
  },

  computed: {
    // 人员调配以服务单为单位，不使用商品明细的选中数据。
    selectedServiceOrders() {
      return this.tableData.filter(item => item.checked)
    },
  },

  created() {
    // let that = this;
    // // console.log(that.$route.name);
    // document.onkeypress = function (e) {
    //   var keycode = document.all ? event.keyCode : e.which;
    //   if (keycode == 13) {
    //     that.$route.name === 'menu3_follow_inspect_inspect' ? that.startOperation() : ''
    //     return false;
    //   }
    // };
    //获取当前用户所在工作组下的所有管理员部门
    this.$api.getAuthWorkGroupAdminDepart({ format_list: 1 }).then(res => {
      this.adminList = res.data
    })
    //服务单-可选检品操作人员
    this.$api.optionServiceApi.usableAdminList().then(res => {
      this.jList = res.data
    })
    //服务单-服务单类型
    this.$api.optionServiceApi.cateList().then(res => {
      this.cateList = res.data
    })

    this.optionServiceList()
  },

  methods: {
    serviceChecked() {
      this.serviceCheckedAll = this.tableData.length > 0 && this.tableData.every(item => item.checked)
    },
    allServiceChecked(value) {
      this.tableData.forEach(item => { item.checked = value })
    },
    openBatchDispatch() {
      if (!this.selectedServiceOrders.length) {
        return this.$message.warning(this.$t('message.operationDataIsNotSelected'))
      }
      this.$refs.batchServiceAdminDispatch.open(this.selectedServiceOrders)
    },
    // 服务单类型-按钮类型
    setType(type) {
      switch (type) {
        case 1:
          return 'info'
          break;
        case 2:
          return 'primary'
          break;
        case 3:
          return 'success'
          break;
        case 4:
          return 'warning'
          break;
        case 5:
          return 'danger'
          break;
        default:
          return ''
          break;
      }
    },
    TabCount() {
      // 服务单-服务单类型数量
      this.$api.optionServiceApi.listTabCount({ cate_id: 5 }).then((res) => {
        this.listTabCount = res.data
      })
    },
    // 获取列表
    optionServiceList() {
      this.TabCount()
      this.$api.optionServiceApi.optionServiceList(this.datas).then((res) => {
        // 为所有商品设置单选框参数
        res.data.data.forEach((orderItem) => {
          orderItem.total = []
          orderItem.checked = false
          orderItem.option_service_detail.forEach((item) => {
            item.extra_options.forEach(extraItem => {
              let existingItem = orderItem.total.find(totalItem => totalItem.name == extraItem.name)
              if (existingItem) {
                existingItem.should += extraItem.should - 0
              } else {
                orderItem.total.push({
                  name: extraItem.name,
                  should: extraItem.should - 0
                })
              }
            })
          })
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.serviceCheckedAll = false
      });
    },
    //搜索
    search() {
      this.datas.page = 1;
      this.optionServiceList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 20,
        status: "0",
        datetimeStart: "",
        datetimeEnd: "",
        user_id: "",
        order_sn: "",
        porder_sn: "",
        service_sn: "",
        admin_id: "",
        created_by: "",
        cate_id: 5,
      }
      this.optionServiceList()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.optionServiceList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.optionServiceList();
    },
    // 是否显示商品列表
    isShow(data) {
      data.show = !data.show;
      this.$forceUpdate();
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      this.tableData.forEach((orderItem) => {
        orderItem.option_service_detail.forEach((item) => {
          if (item.checked) {
            this.checkedList.push(item);
          }
        });
      });
      this.$forceUpdate();
    },
    //  全选
    allChecked() {
      this.checked = !this.checked;
      this.checkedList = [];
      this.tableData.forEach((orderItem) => {
        orderItem.option_service_detail.forEach((item) => {
          item.checked = this.checked
          if (item.checked) {
            this.checkedList.push(item);
          }
        });
      });
      this.$forceUpdate();
    },


  },
};
</script>

<style lang='scss' scoped>
@import "@/css/mixin";

/deep/.is-disabled {
  .el-textarea__inner {
    background-color: #fff !important;
    color: #606266;
  }
}

section {
  position: relative;

  .header {
    padding: 0;
  }

  .headerContainer {
    background-color: #f6f6f6 !important;
    padding: 0 !important;
    position: relative;

    .rightContainer {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .footer {
    padding: 0;
    background-color: #f6f6f6 !important;
    margin-top: 0px;

    .footerContainer {
      padding: 0;
    }
  }
}

.leftContainer {
  width: 100% !important;
  display: flex;
  flex-wrap: wrap;

  .Container {
    margin-right: 20px;
    margin-bottom: 20px;
    max-width: 200px;

    /deep/.el-date-editor {
      width: 200px;
    }
  }

  .time {
    margin-right: 20px;
  }
}

// 与检品列表一致，批量操作栏固定在页面底部。
.operation {
  position: sticky;
  bottom: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background-color: #edeff4;

  .service-selection {
    display: flex;
    align-items: center;
    gap: 16px;
  }
}

.table {
  ol {
    display: flex;
    font-size: 14px;
    height: 60px;
    background-color: #edeff4;
    color: #333;
    position: sticky;
    top: 0px;
    left: 240px;
    z-index: 99;


    li {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;

    }
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;

      .template {
        text-align: left;
        width: 100%;

        .row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 6px;
          padding: 0 6px;


          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          .num {
            color: #B4272D;
            width: 50px;
          }

          .name {
            flex: 1;
          }
        }

        .extra_options {
          font-size: 16px;
        }
      }
    }

    .img {
      position: relative;

      img {
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }


    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;

    .template {
      max-height: 100px;
      overflow-y: auto;
    }
  }

  .numberOfgoodsItem {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .time {
      display: flex;
      width: 70px;
    }
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 2.6;

    /deep/ .el-textarea__inner {
      height: 40px;
      padding: 0 2px;
      line-height: 18px;
    }
  }

  .detail {
    margin-bottom: 12px;

    .head {
      padding: 0px 20px;
      border-radius: 4px 4px 0px 0px;
      background-color: #545467;
      font-size: 14px;
      color: #fff;

      .row {
        display: flex;
        padding: 12px 0;
        border-bottom: 1px solid #87879F;

        .checkbox {
          line-height: 40px;
          margin-right: 20px;
        }

        .show {
          cursor: pointer;
          font-size: 30px;
          display: flex;
          justify-content: center;
          align-items: center;

          /deep/.el-button--mini {
            padding: 3px 8px;
            background-color: #F6F6F6;
            color: #666;
            border: 1px solid #F6F6F6;
          }

          i {
            font-size: 16px;
          }
        }

        .item {
          display: flex;
          margin-left: 55px;
          line-height: 40px;

          .el-icon-copy-document {
            line-height: 40px;
          }

          span {
            margin-right: 10px;
          }

          .acli {
            cursor: pointer;
            color: #f9ff57;
            text-decoration: underline;
          }
        }
      }

      .total {
        display: flex;
        flex-wrap: wrap;
        padding: 12px 0;

        .label {
          margin-right: 60px;
        }

        .item {
          margin-right: 36px;

          span {
            margin-left: 10px;
            color: #F9FF57;
          }
        }
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

/deep/ .el-textarea__inner {
  height: 80px;
  padding: 0 2px;
  line-height: 18px;
}

.num-color {
  span {
    color: #c35257;
  }

  .complete {
    color: #2C96E7;
  }
}
</style>
